import { toMedicalFormModel } from 'pages/employee-reviews/complete/employeeReviewCompleteHelpers';
import { MedicalInformationStep } from 'pages/employee-reviews/complete/steps';
import { medicalInformationTopicKey } from 'pages/employee-reviews/shared';
import { EmployeeService } from 'services';
import {
    applyLoadedRecord,
    createEditableTopicState,
    getEditableTopicGating,
    isEditableTopicDirty
} from './editableTopicState';

// The Medical Information topic. The values are special category under UK GDPR and sit behind
// their own action, so they are read and written through the employee's dedicated medical
// endpoints - which are only called for a review that reviews them.
export const medicalInformationTopic = {
    key: medicalInformationTopicKey,
    stepTitle: "Medical Information",
    Step: MedicalInformationStep,
    createInitialState: createEditableTopicState,
    load: (employeeId) => EmployeeService.getMedicalInformation(employeeId),
    loadFailureMessage: "Failed to get the medical information. Please refresh the page.",
    applyLoaded: (response) => applyLoadedRecord(toMedicalFormModel(response)),
    getGating: (state) => getEditableTopicGating(
        state,
        "medical",
        "The employee's medical information could not be loaded. Please refresh the page before continuing."
    ),
    isDirty: isEditableTopicDirty,
    getComment: (state) => state.comment
};
